import React from 'react'
import style from './Header.Module.css'
import Logo from '../Assets/verify/logo.png'
import Arrow from '../Assets/verify/Arrow.png'

const Header = () => {
    return (
        <div className={style.header}><div className={style.container}>
        <div className={style.logo}><img src={Logo} alt="logo" width="150px"/></div>
        <div className={style.salutation}><p className={style.salutaionParagraph}>Welcome abdulroqeeb</p>
        <img src={Arrow} alt="back" width="16px" /><button className={style.signout}>sign out</button></div>
    </div></div>
   
    )

}

export default Header

